import * as React from 'react';
import  request  from '@/server/request';
import config from '@/server/config';
import * as utils from '@/server/utils';
import alert from '@/pages/components/common/alert';
import './scss/login.scss'

interface initProps {
	history: any,
}

class Register extends React.Component <initProps , any> {
	constructor(props: any) {
		super(props);
		this.state = {
			login_way: 'password',
			imgCode: '',
			form: {
				username: '',
				code: '',
			},
			captchakey: '',  // 验证码随机数
			captchaUrl: '',  // 图形验证码地址
			timer: '', // 定时器	
			timerNumber: 120, //
			isOpenTimer: false,
			isSubmit: false,
			// 0 PC会员注册；10 移动版注册；11 报价通注册；12 专家库注册；13 移动版注册(买家部)；默认10，移动版注册
			sourceType: '',
			isInMiniProgram: false // 是否在小程序中
		}
	}

	componentDidMount() {
		this.props.history.replace(`/login?returnUrl=${this.getOuthBackUrl()}&sourceType=${this.state.sourceType}`);
		return;
		this.getGraphic();
		if ((window as any)._hmt) {
			(window as any)._hmt.push(['_trackPageview', '/mobile/uc/build/register']);
		}
		// 判断地址栏是否有sourceType参数
		const querySourceType = utils.getQueryString('sourceType');
		if (querySourceType) {
			this.setState({
				sourceType: querySourceType
			});
		}

		if ((window as any).swan && (window as any).swan.webView) {
			(window as any).swan.webView.getEnv((res: any) => {
	            if (res.smartprogram) {
	            	this.setState({
	            		isInMiniProgram: true
	            	});
	            }
	        });
		}
	}

	render() {
		return (
			<div className="page-login">
				<div className="logo-warrper">
					<img src={require('@/assets/images/mai_logo.png')} alt="" className="logo"/>
				</div>
				<div className="login-form">
					<div className="login-content">
						<input type="text"  placeholder="请输入手机号" className="login-input" value={this.state.form.username} onChange={ (e:any) => this.setForm('username', e.target.value) } />
						<div className="code-warpper">
							<input type="text"   placeholder="请输入图形验证码" value={this.state.imgCode} onChange={ (e:any) => this.setState({ imgCode: e.target.value }) }   className="login-input" />
							<img src={this.state.captchaUrl} alt="" className="code-img" onClick={() => this.getGraphic()}/>
						</div>
						<div className="code-warpper">
							<input type="text" maxLength={6}  placeholder="请输入验证码" className="login-input" value={this.state.form.code}  onChange={ (e:any) => this.setForm('code', e.target.value) } />
							<button type="button" className="code-btn" onClick={() => this.sendMessage()}>{this.state.timerNumber === 120 ? '获取验证码' : this.state.timerNumber}</button>
						</div>
					</div>
					<div className="login-bottom">
						<button className="login-subBtn" onClick={() => this.submitForm()}>快速注册</button>
						<p className="prompt">
							点击注册代表您已阅读
							<a href="//www.ibuychem.com/legalnotice.html" className="link">《买化塑用户服务协议》</a>
							 和
							<a href="javascript: void(0)" className="link" onClick={() => this.navigateLegal()}>《慧正资讯法律声明》</a>
						</p>
					</div>
				</div>
				{
					!this.state.isInMiniProgram ?
					<div className="orther-login">
						<div className="title-box"><p className="title">快速登录</p></div>
						<div className="icon-group">
							<img src={require('@/assets/images/wx.png')} alt="" className="icon" onClick={() => this.isWx()}/>
							<img src={require('@/assets/images/qq.png')} alt="" className="icon" onClick={() => this.toAuth('QQ')}/>
						</div>
					</div>
					: null
				}
			</div>
		)
	}

	private isWx () {
        const ua = navigator.userAgent.toLowerCase();
        if ((ua as any).match(/MicroMessenger/i) == "micromessenger") {
        	this.toWXAuth();
            return true;
        }
        alert.open({
    		promptText: '请在微信环境打开！',
    	})

        return false;
    };
    private async toWXAuth() {
		const returnUrl =  encodeURIComponent(encodeURIComponent(window.location.origin + '/mobile/uc/build'));
	    window.location.href =  `${config.WAPAPI}login/wechat/auth?scope=2&userType=3&returnUrl=${returnUrl}&businessUrl=${this.getOuthBackUrl()}`;
	}

	private getOuthBackUrl() {
		const returnUrl = GetQueryString('returnUrl');
		function GetQueryString(name: any)
		{
		     var reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
		     var r = window.location.search.substr(1).match(reg);
		     if(r!=null)return  unescape(r[2]); return null;
		}

		if(returnUrl) {
			
			return returnUrl ? encodeURIComponent(returnUrl) : ''
		}else {
			return encodeURIComponent(encodeURIComponent(window.location.origin + '/mobile/uc/build'))
		}
	}

	private async toAuth(type: any) {
		const returnUrl =  encodeURIComponent(encodeURIComponent(window.location.origin + '/mobile/uc/build'));
	    window.location.href =  `${config.WAPAPI}oauth?type=${type}&returnUrl=${returnUrl}&businessUrl=${this.getOuthBackUrl()}`;
	}

	// 获取验证码
	private getGraphic() {
		const text = Math.random() * Math.pow(10,17);
		const url = config.WAPAPI + 'captcha/image?captchakey=' + text;

		this.setState({
			captchaUrl: url,
			captchakey: text,
		})
	}

	// 表单赋值
	private setForm(name?: string, val?: any) {

		if(!name) {
			return ;
		}
		this.state.form[name] = val;
		this.setState({
			form: { 
				...this.state.form,
			} 
		})
	}

	// 发送短信
	private sendMessage() {
		const that = this;
		if (this.state.isOpenTimer) {
			return;
		}
		if (this.state.form.username.replace(/\s/gi, '') === '') {
			alert.open({
				promptText: '请输入手机号',
			})
			return;
		}
		if (this.state.imgCode.replace(/\s/gi, '') === '') {
			alert.open({
				promptText: '请输入图形验证码',
			})
			return;
		}
		this.setState({
			isOpenTimer: true
		}, () => {
			const data = request({
				method: "get",
				url: `${config.API2}sms/send`,
				data: {
					type: 1,
					mobile: this.state.form.username,
					captchakey: this.state.captchakey,
					imgCode: this.state.imgCode,
				}
			});

			data.then(r => {
				if (r.code === 1) {
					// 如果成功 开启定时器
					that.setState({
						timer: setInterval(() => {
							if (that.state.timerNumber > 0) {
								that.setState({
									timerNumber: this.state.timerNumber - 1,
								})
							} else {
								//  重置定时器
								clearInterval(this.state.timer);
								that.getGraphic();
								that.setState({
									isOpenTimer: false,
									timer: '',
									timerNumber: 120,
								})
							}
						}, 1000)
					})


				} else {
					that.getGraphic();
					that.setState({
						isOpenTimer: false,
					}, () => {
						alert.open({
							promptText: r.msg,
						})
					})
				}
			})
		})
	}

	// 检查表单
	private checkForm() {
		if(this.state.form.code.replace(/\s/gi, '') === '') {
			alert.open({
				promptText: '请输入验证码',
			})

			return ;
		}
		if(this.state.form.username.replace(/\s/gi, '') === '') {
			alert.open({
				promptText: '请输入手机号',
			})
			return ;
		}
		return true;
	}

	// 提交表单
	private async submitForm() {
		const that = this;
		if (!this.state.isSubmit) {
			if (!this.checkForm()) {
				return;
			}
			// 防止重复提交
			this.setState({
				isSubmit: true,
			})
			
			const returnUrl = decodeURIComponent(decodeURIComponent(this.getOuthBackUrl()));
			
			const r = await request({
				method: "post",
				url: `${config.WAPAPI}security/register`,
				data: {
					mobile: this.state.form.username,
					sys: 1,
					smsCode: this.state.form.code,
					sourceDevice: 2,
					returnUrl: returnUrl ? returnUrl : '',
					//sourceType: this.state.sourceType
				}
			});
			that.setState({
				isSubmit: false,
			}, () => {
				if (r.code !== 1) {
					alert.open({
						promptText: r.msg,
					})
				} else {
					(window as any).mhs_sso.setCookie(config.ENV === 'development' ? 0 : 1, r.obj.token, () => {
						that.setState({
							form: {
								username: '',
								code: '',
							}
						}, () => that.props.history.push(`/set_password?from=register&returnUrl=${this.getOuthBackUrl()}`))
					});

				}
			})
		}
	}
	private navigateLegal() {
		window.location.href = `${config.HZAPI}mobile/build/legal`;
	}

}

export default Register;